import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import UserControls from 'flarum/forum/utils/UserControls';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
export { default as extend } from './extend';
app.initializers.add('flarum-audit', () => {
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (!app.forum.attribute('canAuditDiscussion')) {
      return;
    }
    items.add('flarum-audit-user', m(Button, {
      icon: "fas fa-book",
      onclick: () => app.modal.show(() => import(/* webpackChunkName: 'forum/components/DiscussionAuditModal', webpackMode: 'lazy-once' */ './components/DiscussionAuditModal'), {
        discussion
      })
    }, app.translator.trans('flarum-audit.forum.link.discussion-audit')));
  });
  extend(UserControls, 'moderationControls', function (items, user) {
    if (!app.forum.attribute('canAuditUser')) {
      return;
    }
    items.add('flarum-audit-user', m(Button, {
      icon: "fas fa-book",
      onclick: () => app.modal.show(() => import(/* webpackChunkName: 'forum/components/UserAuditModal', webpackMode: 'lazy-once' */ './components/UserAuditModal'), {
        user
      })
    }, app.translator.trans('flarum-audit.forum.link.user-audit')));
  });
  extend(UserControls, 'moderationControls', function (items, user) {
    if (!app.forum.attribute('canAudit')) {
      return;
    }
    items.add('flarum-audit-actor', m(Button, {
      icon: "fas fa-book",
      onclick: () => app.modal.show(() => import(/* webpackChunkName: 'forum/components/ActorAuditModal', webpackMode: 'lazy-once' */ './components/ActorAuditModal'), {
        user
      })
    }, app.translator.trans('flarum-audit.forum.link.actor-audit')));
  });
  extend(SessionDropdown.prototype, 'items', function (items) {
    if (!app.forum.attribute('canAudit')) {
      return;
    }
    items.add('flarum-audit', m(Button, {
      icon: "fas fa-book",
      onclick: () => app.modal.show(() => import(/* webpackChunkName: 'forum/components/AuditModal', webpackMode: 'lazy-once' */ './components/AuditModal'))
    }, app.translator.trans('flarum-audit.forum.link.all-audit')), 20); // Value above zero, so it doesn't end up below the admin link
  });
});flarum.reg.addChunkModule('936', '576', 'flarum-audit', 'forum/components/DiscussionAuditModal');
flarum.reg.addChunkModule('985', '985', 'flarum-audit', 'forum/components/UserAuditModal');
flarum.reg.addChunkModule('767', '137', 'flarum-audit', 'forum/components/ActorAuditModal');
flarum.reg.addChunkModule('920', '364', 'flarum-audit', 'forum/components/AuditModal');
flarum.reg.addChunkModule('936', '576', 'flarum-audit', 'common/routeHelpers');
flarum.reg.addChunkModule('936', '576', 'flarum-audit', 'common/components/AuditItem');
flarum.reg.addChunkModule('936', '576', 'flarum-audit', 'common/components/AuditBrowser');